import "./src/styles/global.css"
import Provider from "./src/components/el/provider"
export const wrapRootElement = Provider
